import { render, staticRenderFns } from "./ReadingCardCreateDialog.vue?vue&type=template&id=1b918db3&scoped=true"
import script from "./ReadingCardCreateDialog.vue?vue&type=script&lang=ts"
export * from "./ReadingCardCreateDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b918db3",
  null
  
)

export default component.exports